// YF, Sarah Holt 9 Aug 2026: guarded per Fleur's diagnosis. #CollectionProductGrid only
// exists on collection pages, so the unguarded appendChild threw TypeError on every other
// page (cart included), halting whatever ran after it in this script. This relocates the
// Halo sidebar into the collection toolbar on collection pages, same as before, and does
// nothing (safely) everywhere else.
const x = document.querySelector("#halo-sidebar");
const target = document.querySelector("#CollectionProductGrid > toolbar-item > div:nth-child(2)");
if (x && target) target.appendChild(x);